$(function () {
  if (window.POC.rights_managed_pricing !== undefined) {
    const rights_managed_pricing = window.POC.rights_managed_pricing;
    const $priceDisplay = $('.js-calculated-price');
    const $productSelect = $('#payment_product_id');
    const $durationSelect = $('#payment_provisioning_data_duration');
    const $channelSelect = $('#payment_provisioning_data_channel');
    const $submitButton = $('#new_payment input[type=submit]');

    $productSelect.change(function(){
      calculcateAndDisplayPrice();
    });

    $durationSelect.change(function(){
      calculcateAndDisplayPrice();
    });

    $channelSelect.change(function(){
      calculcateAndDisplayPrice();
    });

    const calculcateAndDisplayPrice = () => {
      if ($productSelect.val() !== '' && $durationSelect.val() !== '' && $channelSelect.val() !== '') {
        let baseCost = rights_managed_pricing.products.find(p => p.id === $productSelect.val()).cost
        let price = baseCost * rights_managed_pricing.brand_index_factors[rights_managed_pricing.asset_brand_index] * rights_managed_pricing.channel_factors[$channelSelect.val()] * rights_managed_pricing.duration_factors[$durationSelect.val()] / 100.0;
        $priceDisplay.text(`$${price.toFixed(2)}`)
        $submitButton.attr('disabled', false)
      } else {
        $priceDisplay.text('')
        $submitButton.attr('disabled', true)
      }
    }
  }
});